function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/yup/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 26
// module chunks = 0